import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '../../../translation/services/translation.service';

@Pipe({
  name: 'translate',
  pure: false
})
export class TranslatePipe implements PipeTransform {

  // Constructor
  constructor(private _translate: TranslationService) {}

  // Transform
  transform(value: any, args?: string | string[]): any {
    if (!value) { return; }
    return this._translate.instant(value, args);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/translate/translate.pipe.ts